import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Container, Grid, Image, Box, Typography } from '@iho-design-system/Loader';

/*
    - component
*/
import BannerComponent from '../components/dashboard/Banner';
import ChartComponent from '../components/dashboard/Chart';
import EditFormComponent from '../components/dashboard/EditForm';
import PaymentModalComponent from '../components/dashboard/PaymentModal';
import RankComponentB2B from '../components/dashboard/Rank-b2b';
import RankComponentB2C from '../components/dashboard/Rank-b2c';
import ReserveComponent from '../components/dashboard/Reserve';
import TitleComponent from '../components/dashboard/Title';

/*
    - icon
*/
import AlertSettlementSVG from '../assets/images/icons/alert-settlement.svg';

/*
    - api
*/
import getAPI from '../api/get';

const Dashboard = ({ reloadHeaderProps }) => {

const mobileImage = 'https://cdn.iranhotelonline.com/images/profile_top_banner_mobile.jpg';
const [showBanner, setShowBanner] = React.useState(true);
    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [reloadDashboard, setReloadDashboard] = React.useState('');
    const [reportType, setReportType] = React.useState(1);
    const [dashboardData, setDashoardData] = React.useState({
        activeReserves: '',
        bankAccount: '',
        buyAmountReport: '',
        citiesAndStates: '',
        dashboardBoxesData: '',
        nightReservesCount: '',
        passengerProfile: '',
        totalReservesPrice: '',
        userCompaniesHistory: '',
        userPlanDetails: '',
        userProfile: '',
        userRegisterTypes: '',
        walletBalance: ''
    });

    /*
        - alert
    */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 2500);
    }

    /*
        - fetchData
    */
        React.useEffect(() => {
            const fetchData = async () => {
        
                const commonData = {};
                const b2bData = {};
                const b2cData = {};
        
                /* -------- مشترک -------- */
                commonData.activeReserves = await getAPI({
                    ctrl: 'UserProfile',
                    method: 'GetActiveReserves',
                    query: '5'
                });
        
                commonData.bankAccount = await getAPI({
                    ctrl: 'BankAccount',
                    method: 'GetAll',
                    query: ''
                });
        
                commonData.nightReservesCount = await getAPI({
                    ctrl: 'UserProfile',
                    method: 'NightReservesCount',
                    query: ''
                });
        
                commonData.passengerProfile = await getAPI({
                    ctrl: 'UserProfile',
                    method: 'GetPassengerProfile',
                    query: ''
                });
        
                commonData.userPlanDetails = await getAPI({
                    ctrl: 'UserProfile',
                    method: 'GetUserPlanDetails',
                    query: ''
                });
        
                /* -------- B2B -------- */
                if (type === 'B2B') {
                    b2bData.buyAmountReport = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetBuyAmountReport',
                        query: reportType
                    });
        
                    b2bData.dashboardBoxesData = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetDashboardBoxesData',
                        query: ''
                    });
        
                    b2bData.totalReservesPrice = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetTotalReservesPrice',
                        query: ''
                    });
        
                    b2bData.userCompaniesHistory = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetuserCompaiesHistory',
                        query: ''
                    });
                }
        
                /* -------- B2C -------- */
                if (type === 'B2C') {
        
                    b2cData.userProfile = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetUserProfile',
                        query: ''
                    });
        
                    b2cData.walletBalance = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetWalletBalanceEx',
                        query: ''
                    });
                    b2cData.walletRequests = await getAPI({
                        ctrl: 'UserProfile',
                        method: 'GetWalletRequests',
                        query: ''
                    });
                }
        
                setDashoardData(prev => ({
                    ...prev,
                    ...commonData,
                    ...b2bData,
                    ...b2cData
                }));
            };
        
            fetchData();
        }, [reloadDashboard, reportType]);
        
    /*
        - reloadDashboardProps
    */
    const reloadDashboardProps = (reloadDashboardProps) => {
        setReloadDashboard(reloadDashboardProps);
        reloadHeaderProps(reloadDashboardProps);
    }

    /*
        - ReportTypeProps
    */
    const ReportTypeProps = (ReportTypeProps) => {
        setReportType(ReportTypeProps);
    }

    /*
        - userRequirement
    */
    let requirement = true;
    if (
        type === 'B2C' &&
        dashboardData.userProfile?.status === 200 &&
        (
            dashboardData.userProfile.data.firstName === '' ||
            dashboardData.userProfile.data.firstName === null ||
            dashboardData.userProfile.data.lastName === '' ||
            dashboardData.userProfile.data.lastName === null ||
            dashboardData.userProfile.data.mobile === '' ||
            dashboardData.userProfile.data.mobile === null
        )
    ) {
        requirement = false;
    }
    

    /*
        - componentData
    */
    let bannerData = [];
    bannerData.bankAccount = dashboardData.bankAccount;
    bannerData.walletBalance = dashboardData.walletBalance;

    let editFormData = [];
    editFormData.passengerProfile = dashboardData.passengerProfile;
    editFormData.userProfile = dashboardData.userProfile;

    let rankData = [];
    rankData.nightReservesCount = dashboardData.nightReservesCount;
    rankData.totalReservesPrice = dashboardData.totalReservesPrice;
    rankData.userPlanDetails = dashboardData.userPlanDetails;

    let reserveData = [];
    reserveData.activeReserves = dashboardData.activeReserves;
    reserveData.userCompaniesHistory = dashboardData.userCompaniesHistory;

    let titleData = [];
    titleData.dashboardBoxesData = dashboardData.dashboardBoxesData;

    let chartData = [];
    chartData.buyAmountReport = dashboardData.buyAmountReport;

    let walletRequestsData = [];
    walletRequestsData.walletRequests = dashboardData.walletRequests;

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large';
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium';
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small';
    } else if (screenWidth <= 576) {
        scale = 'x-small';
    }
  const pendingRequest = Array.isArray(walletRequestsData.walletRequests?.data)
    ? walletRequestsData.walletRequests?.data[0]
    : null;
  const pendingStatus = pendingRequest?.StatusCode;
  const pendingDate = pendingRequest?.DueDate
    ? new Date(pendingRequest.DueDate)?.toLocaleDateString("fa-IR")
    : "";

  const walletSettlementPendingBanner = pendingRequest ? (
    <Grid.Item size="col-12">
      <Box
        className="w-100 d-flex align-item-center mb-lg"
        ms={{
          backgroundColor: "#fff5e7",
          borderRight: "4px solid #ffa500",
          gap: "8px",
          padding: "12px",
        }}
      >
        <Typography
          ms={{
            color: "#E65200",
          }}
        >
          {pendingStatus == 1 ? (
            "درخواست تسویه کیف پول شما در حال بررسی است"
          ) : (
            <>
              تسویه کیف پول و واریز به حساب شما در تاریخ{" "}
              <Box
                component="span"
                ms={{
                  fontWeight: "bold",
                }}
              >
                {pendingDate}
              </Box>{" "}
              انجام خواهد شد
            </>
          )}
        </Typography>
      </Box>
    </Grid.Item>
  ) : null;

    return (
        <React.Fragment>
            {type === 'B2C' &&
                <React.Fragment>
                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                        <Container
                            size='lg'>
                            <Grid>
                                <Grid.Wrapper>
           {walletSettlementPendingBanner}
                                    
                                    {!requirement &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Alert
                                                className={`w-100 position-static`}
                                                color='danger'
                                                ms={{
                                                    boxShadow: 'none !important'
                                                }}
                                                >
                                                      کاربر گرامی، به منظور دسترسی به تمامی امکانات، لطفا اطلاعات ستاره دار فرم زیر را تکمیل نمایید.                                            </Alert>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        size='col-5'>
                                        <EditFormComponent
                                            props={editFormData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-7'>
                                        <BannerComponent
                                            props={bannerData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                        <RankComponentB2C
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {(scale === 'medium' || scale === 'small') &&
                        <Container
                            size='lg'>
                            <Grid>
                                <Grid.Wrapper>
                                    {walletSettlementPendingBanner}
                                    {!requirement &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Alert
                                                className={`w-100`}
                                                color='danger'
                                                ms={{
                                                    boxShadow: 'none !important',
                                                    position: 'static !important'
                                                }}>
کاربر گرامی، به منظور دسترسی به تمامی امکانات داشبورد، لطفا اطلاعات ستاره دار فرم زیر را تکمیل نمایید.
                                            </Alert>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        size='col-5'>
                                        <EditFormComponent
                                            props={editFormData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-7'>
                                        <BannerComponent
                                            props={bannerData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                        <RankComponentB2C
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {scale === 'x-small' &&
                        <Container
                            size='lg'>
                            <Grid>
                                <Grid.Wrapper>
                                    {walletSettlementPendingBanner}
                                    <Grid.Item
                                        size='col-12'>
                                        <BannerComponent
                                            props={bannerData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                        <RankComponentB2C
                                            props={rankData} />
                                    </Grid.Item>
                                    {!requirement &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Alert
                                                className={`w-100`}
                                                color='danger'
                                                ms={{
                                                    boxShadow: 'none !important',
                                                    position: 'static !important'
                                                }}>
کاربر گرامی، به منظور دسترسی به تمامی امکانات داشبورد، لطفا اطلاعات ستاره دار فرم زیر را تکمیل نمایید.
                                            </Alert>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        size='col-12'>
                                        <EditFormComponent
                                            props={editFormData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                </React.Fragment>
            }
            {type === 'B2B' &&
                <React.Fragment>
                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                        <Container
                        size='lg'>
                            <React.Fragment>
                                <TitleComponent
                                    props={titleData} />
                            </React.Fragment>
                            <Grid>
                                <Grid.Wrapper>

                                    <Grid.Item
                                        size='col-6'>
                                        <ChartComponent
                                            props={chartData}
                                            ReportTypeProps={ReportTypeProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <RankComponentB2B
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {( scale === 'small') &&
                        <Container
                            size='lg'>
                            <Box
                                className='p-md d-flex justify-content-center'>
                                {showBanner &&
                            <Image
                                onClick={() => window.open('https://www.iranhotelonline.com/noshahr-hotels/%D9%87%D8%AA%D9%84-%D8%A2%D8%B1%D8%A7%D8%B2/', '_blank')}
                                src={mobileImage}
                                alt='mobileImage'
                                onError={() => setShowBanner(false)}
                                className='rounded-md'
                                ms={{
                                    cursor: 'pointer',
                                    width: '100%',
                                    height: '120px'
                                }} />
                                }
                                </Box>
                            <React.Fragment>
                                <TitleComponent
                                    props={titleData} />
                            </React.Fragment>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <RankComponentB2B
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ChartComponent
                                            props={chartData}
                                            ReportTypeProps={ReportTypeProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {scale === 'x-small' &&
                        <Container
                            size='lg'>
                            <Box
                                className='p-lg'>
                                {showBanner &&
                            <Image
                                src={mobileImage}
                                alt='mobileImage'
                                onError={() => setShowBanner(false)}
                                onClick={() => window.open('https://www.iranhotelonline.com/noshahr-hotels/%D9%87%D8%AA%D9%84-%D8%A2%D8%B1%D8%A7%D8%B2/', '_blank')}
                                className='rounded-lg'
                                ms={{
                                    width: '100%',
                                    height: '120px'
                                }} />
                                }
                                </Box>
                            <React.Fragment>
                                <TitleComponent
                                    props={titleData} />
                            </React.Fragment>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <RankComponentB2B
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ChartComponent
                                            props={chartData}
                                            ReportTypeProps={ReportTypeProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                </React.Fragment>
            }
            <PaymentModalComponent />
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    );

}

export default Dashboard;